import { render, staticRenderFns } from "./Contractors.vue?vue&type=template&id=3d89d4c0&"
import script from "@/views/Contractors/Contractors.ts?vue&type=script&lang=ts&"
export * from "@/views/Contractors/Contractors.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
